import confetti from 'canvas-confetti';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

export function launchConfetti(themeService: ThemeService) {
  setTimeout(() => {
    const canvas = document.querySelector('canvas-confetti') as HTMLCanvasElement;
    if (canvas) {
      canvas.style.zIndex = '9999'; // Set the z-index to a high value
    }

    const myCanvas = document.getElementById('myConfettiCanvas') as HTMLCanvasElement;

    confetti.create(myCanvas, {
      resize: true, // Will fit the canvas to the size of the window
    })({
      particleCount: 100,
      spread: 70,
      origin: { y: 1.0 },
      colors: themeService.confettiColors(),
    });
  }, 250); // Adjust the timeout if necessary
}
